// data/gsPayTables.js

// 2025 General Schedule pay tables with 1.7% increase effective January 2025
export const gsPayTables = {
  base: {
    // GS-1
    1: [22360, 23110, 23853, 24594, 25336, 25770, 26506, 27247, 27277, 27970],
    // GS-2
    2: [25142, 25740, 26573, 27277, 27583, 28394, 29205, 30016, 30827, 31638],
    // GS-3
    3: [27434, 28348, 29262, 30176, 31090, 32004, 32918, 33832, 34746, 35660],
    // GS-4
    4: [30795, 31822, 32849, 33876, 34903, 35930, 36957, 37984, 39011, 40038],
    // GS-5
    5: [34454, 35602, 36750, 37898, 39046, 40194, 41342, 42490, 43638, 44786],
    // GS-6
    6: [38407, 39687, 40967, 42247, 43527, 44807, 46087, 47367, 48647, 49927],
    // GS-7
    7: [42679, 44102, 45525, 46948, 48371, 49794, 51217, 52640, 54063, 55486],
    // GS-8
    8: [47265, 48841, 50417, 51993, 53569, 55145, 56721, 58297, 59873, 61449],
    // GS-9
    9: [52205, 53945, 55685, 57425, 59165, 60905, 62645, 64385, 66125, 67865],
    // GS-10
    10: [57489, 59405, 61321, 63237, 65153, 67069, 68985, 70901, 72817, 74733],
    // GS-11
    11: [63163, 65268, 67373, 69478, 71583, 73688, 75793, 77898, 80003, 82108],
    // GS-12
    12: [75706, 78230, 80754, 83278, 85802, 88326, 90850, 93374, 95898, 98422],
    // GS-13
    13: [90025, 93026, 96027, 99028, 102029, 105030, 108031, 111032, 114033, 117034],
    // GS-14
    14: [106382, 109928, 113474, 117020, 120566, 124112, 127658, 131204, 134750, 138296],
    // GS-15
    15: [125133, 129304, 133475, 137646, 141817, 145988, 150159, 154330, 158501, 162672]
  },
  salaryCap: 195200
};